/* eslint-disable camelcase */
import { HexColor, Location, LocationMapper } from '@nx-smartmonkey/shared/domain';
import { Vehicle } from '../domain/vehicle/Vehicle';
import { VehicleRepositoryDTO } from '../domain/vehicle/VehicleRepositoryDTO';
import { VehicleEntry } from '../entries/VehicleEntry';

class VehicleMapper {
  static toDomain(props: VehicleEntry): Vehicle {
    const {
      id,
      organization_id,
      project_id,
      external_id,
      label,
      phone,
      email,
      comments,
      default_start_location,
      default_end_location,
      default_time_window,
      color,
      updated_at,
      fuel_type,
      consumption,
    } = props;

    return Vehicle.create(
      {
        organization_id,
        project_id,
        external_id,
        label,
        phone,
        email,
        fuel_type,
        consumption,
        comments,
        default_start_location: default_start_location ? Location.create(default_start_location) : undefined,
        default_end_location: default_end_location ? Location.create(default_end_location) : undefined,
        default_time_window,
        color: color ? HexColor.create(color) : undefined,
        updated_at,
      },
      id
    );
  }

  static toRepository(vehicle: Vehicle): VehicleRepositoryDTO {
    const { label, email, fuel_type, consumption, default_start_location, default_end_location, default_time_window } =
      vehicle;
    return {
      label,
      email,
      fuel_type,
      consumption,
      ...(default_start_location !== undefined
        ? {
            default_start_location:
              default_start_location !== null ? LocationMapper.toDTO(default_start_location) : null,
          }
        : {}),
      ...(default_end_location !== undefined
        ? {
            default_end_location: default_end_location !== null ? LocationMapper.toDTO(default_end_location) : null,
          }
        : {}),
      default_time_window,
    };
  }
}

export default VehicleMapper;
